(function(){

  class PaymentIcons extends HTMLElement {
      constructor() {
        super();
        this.el = this;
        this.$source = document.querySelector('#payment-icons-template');
        this.source = this.$source ? this.$source.innerHTML : '';
        this.exclusions = [...this.el.dataset.exclusions.split(',')].filter((str) => str.length);

        // console.log('Payment Icon Exclusions?', this.exclusions, this.el);

        this.setup();
      }

      getElement() {
        let $div = document.createElement('div');
        let $el = this.$source.cloneNode(true);

        $el.id = '';
        $div.appendChild($el)

        return $div;
      }

      setup() {
        if(!this.exclusions.length) {
          this.el.appendChild(this.getElement());
          return;
        }

        let $container = this.getElement();
        
        [...this.exclusions].forEach((type) => {
          let $item = $container.querySelector(`[data-type="${type}"]`);

          if($item) $item.parentElement.removeChild($item);
        })

        this.el.appendChild($container);
      }
  }

  customElements.define('payment-icons', PaymentIcons);
})();

console.log('Load Payment Icons');